import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import "./ReconciliationSidebarLanding.css";

import ReportsInDetail from "./ReportsInDetail";
import ReportsOverview from "./ReportsOverview";
import ReportDetailNavigation from "./ReportDetailNavigation";

import FadeLoader from "react-spinners/FadeLoader";
import { overrideSidebar } from "@safecv/shared/sharedFunction";
import { getReconciliationReport } from "@safecv/actions/postActions";

const ReconciliationSidebarLanding = (props) => {
  const {
    jobId,
    reconciliationReport,
    setSelectedReconciliation,
    reconciliationReportLoading,
    setIsReconciliationSidebarOpen,
  } = props;

  const [isOpenReportsDetail, setIsOpenReportsDetail] = useState(false);

  useEffect(() => {
    props.getReconciliationReport(jobId);
  }, []);

  return (
    <>
      <div className="reconciliation-sidebar-container">
        <div className="reconciliation-sidebar-header">
          <div className="reconsidebar-header-title">Reconciliation Report</div>
          <div
            className="reconsidebar-header-image"
            onClick={() => {
              setSelectedReconciliation(null);
              setIsReconciliationSidebarOpen(false);
            }}
          >
            X
          </div>
        </div>

        {!reconciliationReportLoading ? (
          <>
            <ReportDetailNavigation
              isOpenReportsDetail={isOpenReportsDetail}
              reconciliationReport={reconciliationReport}
              setIsOpenReportsDetail={setIsOpenReportsDetail}
              setSelectedReconciliation={setSelectedReconciliation}
            />

            <div className="reconciliation-sidebar-section-counts">
              <div className="reconsidebar-section-counts-texts">
                <span>
                  <span>
                    Index Count &nbsp;
                    {reconciliationReport?.metadata?.index_count || 0}
                  </span>
                </span>
                <span style={{ marginLeft: "25px" }}>
                  <span>
                    Plan Document Count &nbsp;
                    {reconciliationReport?.metadata?.pages_count || 0}
                  </span>
                </span>
              </div>
            </div>

            {isOpenReportsDetail ? (
              <ReportsInDetail
                reconciliationReport={reconciliationReport}
                setSelectedReconciliation={setSelectedReconciliation}
              />
            ) : (
              <ReportsOverview reconciliationReport={reconciliationReport} />
            )}
          </>
        ) : (
          <FadeLoader
            height={15}
            width={5}
            radius={2}
            margin={2}
            color={"#4183C5"}
            css={overrideSidebar}
            loading={reconciliationReportLoading}
          />
        )}
      </div>
    </>
  );
};

const mapStatetoProps = (state) => ({
  reconciliationReport: state.verification.reconciliationReport,
  reconciliationReportLoading: state.verification.reconciliationReportLoading,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    getReconciliationReport: (jobId) => {
      dispatch(getReconciliationReport(jobId));
    },
  };
};

export default connect(
  mapStatetoProps,
  mapDispatchtoProps
)(ReconciliationSidebarLanding);
